import { getConvertedDateToCST } from 'Utils/time';
import INVESTMENT_CONST from 'Const/investment.json';

const { SM_STATUS } = INVESTMENT_CONST;

export default {
  marketOfferList: state => state.marketOfferList.filter(item => ![SM_STATUS.SOLD, SM_STATUS.CANCELLED].includes(item.status)),
  isSomeMarketOffer: state => Boolean(state.marketOfferList.length),
  marketUserBidList: state => state.marketUserBidList || [],
  marketUserBidListFunding: (state, getters) => getters.marketUserBidList
    .filter(item => [SM_STATUS.ACTIVE, SM_STATUS.ACCEPTED, SM_STATUS.CONFIRMED].includes(item.status)),
  isTradingHours: () => {
    const now = new Date();
    const [dateString] = now.toISOString().split('T');
    const openTime = getConvertedDateToCST(`${dateString}T09:30`);
    const closeTime = getConvertedDateToCST(`${dateString}T16:00`);
    return now.getTime() > openTime.getTime() && now.getTime() < closeTime.getTime();
  },
  marketUserBidListFundingCount: (state, getters) => getters.marketUserBidListFunding.length,
};
